<template>
  <div id="universal-form" class="row card-collapse universal-form">
    <patient-form ref="patientForm"
      @saveData="$emit('saveData')"
      @beforeSave="isValid()"
      :formData="formData.patient"
      :editable="hasPermission('ApplicationsTitan', 'U') && !accepted"
      :show-action-button="false"
    />
    <titan-form ref="contentForm"
      :schema="contentDataSchema"
      :model="formData.contentData"
      v-on:saveData="$emit('saveData')"
      @beforeSave="$emit('validate')"
      :showMessage="false"
      :newItem="true"
      :editable="hasPermission('ApplicationsTitan', 'U')"
      :show-action-button="false"
    />
    <attachments :applications-attachments="formData.applicationsAttachments" />
    <div id="main-save" class="main-save " :class="scrolledToBottom ? 'non-fixed':'fixed'">
      <b-button v-on:click="isValid() && $emit('saveData')" variant="primary">{{ t('Save') }}</b-button>
    </div>
  </div>
</template>

<script>
  import VueFormGenerator from 'vue-form-generator'
  import FormGenerator from '../../../core/Form/vfg/formGenerator'
  import TitanForm from '../../../core/Form/Form'
  import PatientForm from '../patients/form'

  import Attachments from './attachments';
  import AcceptAction from '../../../core/AcceptAction'
  import FieldRadios from 'vue-form-generator'

  import { validateMultipleForms } from '../../../core/Libs/utils'
  import { apiLink } from '../../../store/api'
  import { get } from 'lodash'

  export default {
    components: {
      AcceptAction,
      TitanForm,
      PatientForm,
      FieldRadios,
      'vue-form-generator': FormGenerator,
      Attachments,
    },
    props: {
      formData: {
        type: Object,
        required: true,
      },
      accepted: {
        type: Boolean,
        default: true,
      },
    },
    created() {
      //this.positionActionPanel();
      window.addEventListener('scroll', this.positionActionPanel)
      window.addEventListener('resize', this.positionActionPanel)

    },
    mounted() {
      let aoForms = Object.values(this.formData.protocol.schema.forms)
      aoForms.forEach(formDef => {
        let formSchema = {
          name: formDef.label,
          type: 'main',
          model: formDef.variable,
          fields: [],
        }
        let aoFields = Object.values(formDef.fields)
        aoFields = aoFields.sort((a, b) => (a.order > b.order) ? 1 : -1)
        aoFields.forEach(fieldDef => {
          fieldDef.frontSchema.formModel = formSchema.model
          if (fieldDef.type === 'titanAutocomplete') {
            fieldDef.frontSchema.minStringLength = -1;
          }
          if (! fieldDef.label && ! fieldDef.labelSk) {
            fieldDef.label = undefined;
            fieldDef.labelSk = undefined;
            fieldDef.frontSchema.label = undefined;
            fieldDef.frontSchema.label = undefined;
          }

          formSchema.fields.push(fieldDef.frontSchema)
        })
        this.contentDataSchema.push(formSchema)
      })
      this.getAllFieldSchemas().forEach(fieldSchema => {
        if (fieldSchema.required) {
          fieldSchema.validator = VueFormGenerator.validators.required
        }
        if (fieldSchema.label && fieldSchema.label.includes('{')) {
          fieldSchema.labelTemplate = fieldSchema.label
          let fieldVar = fieldSchema.label.match(/\{([^)]+)\}/)[1]
          fieldSchema.label = fieldSchema.labelTemplate.replace('{' + fieldVar + '}', '')
          let replaceFieldSchema = this.getFieldSchema(fieldVar)
          if (typeof replaceFieldSchema === 'object' && replaceFieldSchema !== null) {
            replaceFieldSchema.onChanged = (model, newVal, oldVal, changedField) => {
              if (typeof newVal === 'object' && newVal !== null && newVal.hasOwnProperty('value')) {
                newVal = newVal.name
              }
              if (newVal === null) newVal = ''
              fieldSchema.label = fieldSchema.labelTemplate.replace('{' + fieldVar + '}', newVal)
            }
          }
        }
        if (typeof fieldSchema.visible === 'string' && fieldSchema.visible.length > 0) {
          let subConditions = fieldSchema.visible.split('&')
          let conditionsDef = []
          subConditions.forEach(subCond => {
            let defParts = subCond.replace(/\s+/g, '').split('=')

            conditionsDef.push({
              'fieldModel': { 'form': fieldSchema.formModel, 'field': defParts[0] },
              'expectedValue': defParts[1].replace('(', '').replace(')', '').split(','),
            })
          })
          fieldSchema.visible = (model) => {
            let result = 1
            conditionsDef.forEach(cond => {
              let condField;
              if (cond.fieldModel.field.match(/^formData\./))  {
                condField = get(this.formData, cond.fieldModel.field.replace('formData.', ''))
                // console.log(JSON.stringify({f: cond.fieldModel.field, k: cond.fieldModel.field.replace('formData.' , ''), condField}, null, 2))
              } else {
                condField = model[cond.fieldModel.form][cond.fieldModel.field]
              }
              let condFieldValue = null
              if (typeof condField === 'object' && condField !== null && condField.hasOwnProperty('value')) {
                condFieldValue = condField.value.toString()
              } else if (condField !== null) {
                condFieldValue = condField.toString()
              }
              result *= cond.expectedValue.includes(condFieldValue)
            })
            return Boolean(result)
          }
        }

        if (typeof fieldSchema.disabled === 'string' && fieldSchema.disabled.length > 0) {
          let subConditions = fieldSchema.disabled.split('&')
          let conditionsDef = []
          subConditions.forEach(subCond => {
            let defParts = subCond.replace(/\s+/g, '').split('=')
            conditionsDef.push({
              'fieldModel': { 'form': fieldSchema.formModel, 'field': defParts[0] },
              'expectedValue': defParts[1].replace('(', '').replace(')', '').split(','),
            })
          })
          fieldSchema.disabled = (model) => {
            let result = 1
            conditionsDef.forEach(cond => {
              let condField;
              if (cond.fieldModel.field.match(/^formData\./))  {
                condField = get(this.formData, cond.fieldModel.field.replace('formData.', ''))
                // console.log(JSON.stringify({f: cond.fieldModel.field, k: cond.fieldModel.field.replace('formData.' , ''), condField}, null, 2))
              } else {
                condField = model[cond.fieldModel.form][cond.fieldModel.field]
              }
              let condFieldValue = null
              if (typeof condField === 'object' && condField !== null && condField.hasOwnProperty('value')) {
                condFieldValue = condField.value.toString()
              } else if (condField !== null) {
                condFieldValue = condField.toString()
              }
              result *= cond.expectedValue.includes(condFieldValue)
            })
            return Boolean(result) || this.formData.status.slug === 'accepted'
          }
        }

      })

      setTimeout(() => {
        this.scrolledToBottom = false
        this.resizeActionPanel()
      }, 50)
    },
    watch: {},
    computed: {
      uploadFileUrl() {
        return apiLink() + 'applications/upload-file/' + this.$route.params.id + '?XDEBUG_SESSION_START=titan'
      },
      uploadEncryptedFileUrl() {
        return apiLink() + 'applications/upload-file-encrypted/' + this.$route.params.id + '?XDEBUG_SESSION_START=titan'
      },
    },
    methods: {
      getAllFieldSchemas() {
        let allFieldSchemas = []
        this.contentDataSchema.forEach(formSchema => {
          let formFields = Object.values(formSchema.fields)
          formFields.forEach(fieldSchema => {
            allFieldSchemas.push(fieldSchema)
          })
        })
        return allFieldSchemas
      },
      getFieldSchema(variable) {
        let found = this.getAllFieldSchemas().filter(f => f.model === variable)
        if (Array.isArray(found) && found.length === 1) {
          return found[0]
        }
        return null
      },
      getFieldValue(variable) {
        let found = null
        Object.values(this.formData.contentData).forEach(fields => {
          if (fields.hasOwnProperty(variable)) {
            found = fields[variable]
          }
        })
        return found
      },
      resizeActionPanel() {
        let el = document.querySelector('#universal-form')
        if (el) {
          let bb = el.getBoundingClientRect()
          let width = bb.right - bb.left
          document.getElementById('main-save').style.width = width + 'px'

        }
      },
      positionActionPanel() {
        setTimeout(() => {
          let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + (window.innerHeight + 125) > document.documentElement.offsetHeight
          if (bottomOfWindow) {
            this.scrolledToBottom = true

          } else {
            this.resizeActionPanel()
            this.scrolledToBottom = false
          }
        }, 100)
      },
      index(obj, i) {
        return obj[i]
      },
      eraseHiddenValues() {
        //console.log('TODO: should erase hidden values');
      },
      isValid() {
        //this.eraseHiddenValues();
        return validateMultipleForms([
          this.$refs.patientForm,
          this.$refs.contentForm,
        ])
      },
      loadAttachmentsData() {
        this.$store.dispatch('applications/attachments', this.$route.params.id)
      },
    },
    data() {
      return {
        scrolledToBottom: false,
        formOptions: {
          validateAfterLoad: false,
          validateAfterChanged: false,
        },
        loading: false,
        contentDataSchema: [],
      }
    },
  }
</script>

<style lang="scss">

  .vue-form-generator {
    .grid-subform {
      padding-bottom: 10px;
      border-top: 1px solid transparent;
      border-bottom: 1px solid transparent;

      &:hover {
        background: #efefef;
        border-bottom: 1px solid #dadada;
        border-top: 1px solid #dadada;
      }

      label span {
        /*display: inline !important;*/
      }

      .field-titanSwitch {

        .field-wrap {
          position: absolute;
          top: 10px;
        }

        label {
          position: absolute;
          top: 10px;
          left: 75px;

          span {
            display: inline;
          }
        }
      }

    }
  }

  .universal-form {

    .file-row {
      margin-left: 0;
      margin-top: 0;
    }

    .main-save {
      &.fixed {
        /*box-shadow: 0px -3px 2px 1px #efefef;*/
        position: fixed;
        bottom: 0;
        border: 0;
        border-top: 2px solid rgba(0, 0, 0, 0.125);
        border-radius: 0;
      }

      &.non-fixed {
        width: 100%;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        background: white;

      }

      z-index: 1000;
      background: #efefef;
      text-align: center;
      padding-top: 1rem;
      padding-bottom: 1rem;
      border: 1px solid rgba(0, 0, 0, 0.125);
      border-top: 0;
      border-radius: .25rem;
    }

    .form-group.left-float {
      & > label {
        float: left;
        width: 10%;
      }

      .field-wrap {
        float: left;
        margin-left: 0.5rem;
      }
    }

    .form-group.radios-float {
      & > label {
        float: left;
        width: 20%;
      }

      .field-wrap {
        float: left;
        margin-left: 1rem;
      }
    }

    .form-control {
      border-color: #b3b8bd !important;
    }

    .field-label {
      span {
        font-size: 1.2rem;
        margin-left: 0 !important;
      }
    }

    label {
      font-size: 0.9rem;
    }

    .section-header {
      border-bottom: 1px solid lightgrey;
      border-top: 1px solid lightgrey;
      padding: 15px 0;
      margin-top: 0;

      label {
        font-size: 1.25rem;
        span {
          font-size: 1.25rem;
        }
      }

      &:first-child {
        border-top: 0;
        margin-top: -21px;
      }
    }

    .sub-section-header {
      padding: 5px 0;
      margin-top: 0;

      label {
        font-size: 1.25rem;
        span {
          font-size: 1.25rem;
        }
      }
    }

    .table-header {
      font-weight: normal;
      label {
        font-weight: normal !important;
        font-size: 1rem;
        span {
          font-weight: normal;
          font-size: 1rem;
        }
      }
    }

    .form-group.right-label {
      position: relative;
      padding-top: 1.75em;

      label {
        position: absolute;
        left: 75px;
        top: 30px;
      }
    }

    legend {
      padding-top: 0.6rem;
      font-size: 1.2rem;
    }

    .titan-select {
      .multiselect__tags {
        border-color: #b3b8bd !important;
      }
    }

    .titan-switch {
      height: 26px;
      line-height: 26px;
      padding-left: 28px !important;
      font-size: 0.9rem;

      &.switch-off {
        background-color: gray !important;
        padding-left: 6px !important;
      }

      &.switch-on {
        background-color: #3ac165 !important;
        padding-right: 5px !important;

      }
    }

    .titan-form {
      .label-left {
        label {
          float: left;
          padding-top: 0.4em;
          margin-right: 0.4em;
        }

        .field-wrap {
          float: left;
        }
      }

      .label-right {
        label {
          padding-top: 0.6em;
          margin-left: 1em;
        }

        .field-wrap {
          float: left;
          width: 15%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/private/applications/protocol-body.vue